// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner_3I6K2","banner-img":"Banner_banner-img_3vb6w"};